
import { Component, Vue } from 'vue-property-decorator'
import ThemeHomeView from '@/theme/ThemeHome.vue'
import AppContent from '@/views/AppContent.vue'

@Component({
  components: {
    ThemeHomeView,
    AppContent
  }
})
export default class HomeView extends Vue {
  data () {
    return {
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }
}
